export enum PositionType {    
    OpoPosition = 1,
    CenterPosition = 2,
    NkrPosition = 3
}